// extracted by mini-css-extract-plugin
export default {"card":"StatCard_card__yMaSG","accent":"StatCard_accent__aUZtv","label":"StatCard_label__WN2KS","value":"StatCard_value__2wsjP","sub":"StatCard_sub__OHFMJ"};